<template>
    <div class="page">
        <div class="row reports report-monthly">
            <div class="table-responsive">
                <h2>{{reportTitle}}</h2>
                <table class="maintable reports">
                    <thead>
                        <tr>
                            <td>{{$t('DATETIME')}}</td>
                            <td>{{$t('PRODUCT')}}</td>
                            <td>{{$t('QUANTITY')}}</td>
                            <td>{{$t('ISREPEAT')}}</td>
                            <td></td>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(row, i) in report.root" :key="i">
                            <td>{{formatDate(row.updateDateTime)}}</td>
                            <td>{{$t(row.name)}}</td>
                            <td>{{row.num}}</td>
                            <td>{{row.isRepeat}}</td>
                            <td></td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="table-responsive">
                <table class="maintable reports">
                    <thead>
                        <tr>
                            <td></td>
                            <td v-for="product in report.products">{{$t(product.name)}}</td>
                            <td></td>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>{{$t('QUANTITY')}}:</td>
                            <td v-for="product in report.products">{{product.num}}</td>
                            <td></td>
                        </tr>
                        <tr>
                            <td>{{$t('REPEATNUM')}}:</td>
                            <td v-for="product in report.products">{{product.isRepeat}}</td>
                            <td></td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>

<script>

import
{
    mapActions,
    mapGetters
}
from 'vuex'
import dentalsolutiontypesApi from '@/api/dentalsolutiontypes'
import dentalsolutionsApi from '@/api/dentalsolutions'
import moment from 'moment';

export default
{
    name: 'ReportsDs',
    data: function()
    {
        return {
            dentalsolutiontypes: {
                root: [],
                totalCount: 0
            },
            companies: {
                root: [],
                totalCount: 0
            },
            report: {
                root: [],
                totalCount: 0,
            },
            params:
            {
                month: moment().format('M'),
                year: moment().format('YYYY'),
                ordererCompanyId: '',
            }
        };
    },
    created: function()
    {
        var me = this;

        me.params = me.$route.query;

        me.getClientReport();
    },
    methods:
    {
        getClientReport()
        {
            var me = this;
            const params = { ...me.params };

            params.date = moment(params.date).format('YYYY-MM-DD');

            dentalsolutionsApi.getClientReport(params, function(data)
            {
                if (data.error)
                {
                    me.$notify.error(data.notice);
                }
                else
                {
                    me.report = data;
                }
            });
        }
    },
    computed: {
        ...mapGetters([
            'globals'
        ]),
        getQueryParams()
        {
            const me = this;

            return {
                ...me.params,
                date: moment(me.params.date).format('YYYY-MM-DD')            
            }
        },
        reportTitle()
        {
            const me = this;

            if(me.report.reportHeader !== undefined)
            {
                return me.report.reportHeader.date+' '+me.report.reportHeader.companyName;   
            }

            return '';
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/PrintDsClient.vue